/**
 * The platform CRM in the console: the journey of a signed-up company (action log, 20/10/2026) and the list of
 * a questionnaire's sign-ups. Twin of `it.ts`.
 */
export default {
  percorso: {
    titolo: 'Journey',
    prossimo_passo: 'Next step: {{passo}}',
    vuoto: 'No entries yet. The log fills itself at every step with this company.',
    errore: 'The log did not load: {{errore}}',
    autore: {
      sistema: 'automatically',
      skill: 'from the skill',
      console: 'from the console',
    },
    voce: {
      iscrizione: 'Signed up',
      questionario_compilato: 'Filled in a questionnaire',
      email_conferma: 'Confirmation email',
      messaggio: 'We wrote to them',
      risposta_ricevuta: 'They replied',
      questionario_inviato: 'We sent them a questionnaire',
      accesso_attivato: 'Early access activated',
      tetto_raggiunto: 'Reached the daily limit',
      proposta_pagamento: 'Offered the paid plan',
      passato_a_pagamento: 'Moved to a paid plan',
      pausa_inattivita: 'Account paused for inactivity',
      uscito: 'Left the list',
      nota: 'Note',
    },
    passo: {
      valutare_e_proporre: 'assess them and offer early access',
      attendere_risposta: 'waiting for their reply',
      rispondere: 'reply to them',
      attendere_questionario: 'waiting for them to fill in the questionnaire',
      attivare_accesso: 'activate their early access',
      seguire_uso: 'follow how they use it',
      nessuno: 'nothing to do',
    },
  },
  iscritti: {
    cerca: 'Search',
    cerca_esempio: 'name, company, email…',
    provenienza: 'Source',
    tutte: 'All',
    consenso: 'Consent',
    tutti: 'All',
    domanda: 'Question',
    nessun_filtro: 'No filter',
    ha_scelto: 'Chose',
    qualsiasi: 'Any',
    esporta: 'Export CSV ({{n}})',
    colonne: {
      data: 'Date',
      nome: 'Name',
      ruolo: 'Role',
      azienda: 'Company',
      email: 'Email',
      telefono: 'Phone',
      a_che_punto: 'Where they are',
      provenienza: 'Source',
      lingua: 'Language',
      consenso: 'Consent',
      non_contattare: 'Do not contact',
    },
    apri_scheda: 'Open the record',
    scheda_non_leggibile: 'This company’s record cannot be read',
    nessun_iscritto: 'No sign-ups yet.',
    nessuno_coi_filtri: 'No sign-ups match these filters.',
    non_contattare_dal: 'Yes, since {{data}}',
    non_contattare_compatto: 'Do not contact, since {{data}}',
  },
} as const;
